import { useTakeOverAvailable } from './useTakeOverAvailable';

/**
 * Whether the signed-in user may see a chart's sync review: the header
 * control and the Patient Manager count. The one read rule, mirroring the
 * server's `sync_review_readable`. It follows Take Over v2, so the review is
 * hidden while `external-emr-take-over` is off, even where a review is still
 * open (Daniel, 2026-10-14).
 */
export function useSyncReviewReadable(): boolean {
  return useTakeOverAvailable();
}
